import { FeaturedImageFragment } from '@/fragments/FeaturedImage'
import { FlexibleContentFragment } from '@/fragments/FlexibleContent'
import { GravityFormsFragment } from '@/fragments/GravityForms'
import { LeaderProfileFieldsFragment } from '@/fragments/LeaderProfile'
import { LeaderCardFieldsFragment } from '@/fragments/Leaders'
import { PostsFragment } from '@/fragments/Posts'
import { gql } from '@apollo/client'

export const variables = ({ databaseId, uri }, ctx) => {
  return {
    databaseId,
    asPreview: ctx?.asPreview,
    // Only leader pages read the sibling list. Without this every other child page on the
    // site fetches its own siblings and throws them away — /industry/nonprofit/ was
    // pulling seven pages and 2.7KB it never used.
    withLeaderSiblings: Boolean(uri?.startsWith('/leadership/') && uri !== '/leadership/')
  }
}

export const query = gql`
  ${FeaturedImageFragment}
  ${FlexibleContentFragment}
  ${GravityFormsFragment}
  ${LeaderCardFieldsFragment}
  ${LeaderProfileFieldsFragment}
  ${PostsFragment}
  query GetPageData($databaseId: ID!, $asPreview: Boolean = false, $withLeaderSiblings: Boolean = false) {
    page(id: $databaseId, idType: DATABASE_ID, asPreview: $asPreview) {
      title
      seo {
        metaDesc
        title
      }
      ...FeaturedImageFragment
      ...FlexibleContentFragment
      ...LeaderProfileFields
      uri
      parent @include(if: $withLeaderSiblings) {
        node {
          ... on Page {
            children(first: 30, where: { orderby: { field: MENU_ORDER, order: ASC } }) {
              nodes {
                ...LeaderCardFields
              }
            }
          }
        }
      }
      innerHeroFields {
        content
        eyebrowText
        fieldGroupName
        includeForm
        title
        heroLink {
          url
          title
          target
        }
      }
    }
    posts(first: 12) {
      nodes {
        ...PostsFeedItemFragment
      }
    }
    contactForm: gfForm(id: 1, idType: DATABASE_ID) {
      ...GravityFormsFragment
    }
    headerForm: gfForm(id: 2, idType: DATABASE_ID) {
      ...GravityFormsFragment
    }
  }
`
